class VisibilityManager {
    constructor() {
        this.initInfoToggle();
    }

    initInfoToggle() {
        setTimeout(() => {
            $('#professional-info').addClass('hide');
        }, 5000);

        $('#professional-info .icon-info').on('click', () => {
            $('#professional-info').toggleClass('hide');
        });
    }
}